import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import * as Icons from '../icons/Icons';

const propTypes = {
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    progress: PropTypes.number.isRequired
};

export default function UploadProgressIndicator({ name, status, progress }) {
    return (
        <div className="rec-upload-progress">
            <div className={cx("rec-upload-progress-barview", { inactive: progress === 100 })}>
                <span className="rec-upload-progress-name">{name}</span>
                <span className="rec-upload-progress-status">{status}</span>
                <div className="rec-upload-progress-bar-wrapper">
                    <div className="rec-upload-progress-bar" style={{ width: `${progress}%` }} />
                </div>
            </div>

            <div className={cx("rec-upload-progress-success", { active: progress === 100 })}>
                <div className="rec-upload-progress-success-check">
                    <Icons.IconCheckCircle />
                </div>
                <h3>Upload Successful</h3>
                <p>Your image will be live on the website shortly.</p>
            </div>
        </div>
    );
}

UploadProgressIndicator.propTypes = propTypes;
